import Slider from "component/design-system/carousel/Slider";
import PAText from "component/design-system/typography/PAText/PAText";
import { cloneElement } from "react";
import styles from "./sliderCard.module.scss";

interface IProps {
  title: string;
  titleWidth?: number;
  categoryUrls: {
    url: string;
    title: string;
    imgSrc: string;
    tier0: string;
    tier1: string;
    tier2: string;
  }

}

function SliderCard(props: IProps) {
  const { categoryUrls, title, titleWidth } = props;

  return (
    <div className="m-b-20">

      <PAText component="h2" className={styles.h2} bold>{title}</PAText>

      <div>
        <Slider
          tileWidth={titleWidth || 250}
          // autoplay
          showArrowOnHover
          showScrollOnHover
          liClass={styles.slider_li_class}
        >

          {categoryUrls
            .map((categoryUrl: any, index: any) => (
              <>
                {cloneElement(props.children, { ...categoryUrl, key: index })}
              </>
            ))}
        </Slider>
        {/* </ul> */}

      </div>
    </div>
  );
}

export default SliderCard;
